<template>
   <div class="base-dropdown">
      <div class="selector" @click="showModal()">{{ selectedOptionText }}</div>

      <div class="placeholder">{{ placeholder }}</div>
      <div class="caret">
         <i class="fc_dropdown" />
      </div>

      <b-modal
         v-model="modalShown"
         modal-class="base-modal-select"
         body-class="base-modal-select-body"
         :centered="true"
         :hide-header="true"
         :hide-footer="true"
      >
         <div class="nav-list">
            <div
               v-for="opt in options"
               :key="opt.value"
               :class="['nav-item', { selected: isOptSelected(opt) }]"
               @click="optClickListener(opt)"
            >
               {{ opt.text }}
            </div>
         </div>
      </b-modal>
   </div>
</template>

<script>
export default {
   model: {
      prop: 'selectedOption',
      event: 'change',
   },
   props: {
      options: {
         type: Array,
         default: () => [],
      },

      selectedOption: {
         type: String,
         default: null,
      },

      placeholder: {
         type: String,
         default: null,
      },
   },
   data() {
      return {
         selectEl: null,
         modalShown: false,
      };
   },

   computed: {
      selectedOptionText() {
         if (!this.selectedOption) return '';

         let text = '';
         this.options.some(opt => {
            if (opt.value === this.selectedOption) {
               // eslint-disable-next-line prefer-destructuring
               text = opt.text;
               return true;
            }
            return false;
         });

         return text;
      },
   },

   watch: {
      options() {
         this.initSelectedOption();
      },
   },

   created() {
      this.initSelectedOption();
   },

   methods: {
      initSelectedOption() {
         let selectHit = false;

         if (this.selectedOption) {
            selectHit = this.options.some(opt => opt.value === this.selectedOption);
         }

         if (!selectHit && this.options.length) {
            this.$emit('change', this.options[0].value);
         }
      },

      isOptSelected(opt) {
         return opt.value === this.selectedOption;
      },

      optClickListener(opt) {
         this.$emit('change', opt.value);
         this.hideModal();
      },

      showModal() {
         this.modalShown = true;
      },

      hideModal() {
         this.modalShown = false;
      },
   },
};
</script>

<style lang="scss" scoped>
.base-dropdown ::v-deep {
   display: inline-block;
   border: 1px solid rgba(62, 57, 107, 0.13);
   border-radius: 4px;
   position: relative;

   .selector {
      width: 100%;
      display: block;
      padding: 12px 35px 12px 15px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
   }

   .placeholder {
      position: absolute;
      top: -10px;
      left: 12px;
      font-size: 12px;
      font-weight: 600;
      padding: 0px 3px;
      color: #9f9fb9;
      background: #f9f9fc;
      pointer-events: none;
   }

   .caret {
      position: absolute;
      top: 10px;
      right: 12px;
      pointer-events: none;

      i {
         font-size: 12px;
      }
   }

   .badge {
      margin-left: 10px;
      font-size: 11px;
      border-radius: 2px;
      border: 1px solid rgba(62, 57, 107, 0.04);
   }

   .nav-item {
      margin: 5px 0;
      padding: 10px 20px;
      color: rgba(#000, 0.6);
      cursor: pointer;

      &.selected {
         color: #fff;
         background: #6957da;
         border-radius: 4px;
         overflow: hidden;
         box-shadow: 0 4px 9px 0 rgba(23, 28, 33, 0.06);
      }
   }

   .modal {
      .base-modal-select-body {
         height: auto;
         max-height: 75vh;
         overflow: auto;
      }
   }
}
</style>

<style lang="scss">
.base-modal-select {
   padding: 20px 10px;

   .modal-content {
      border-radius: 4px;
      overflow: hidden;
   }
}

.base-modal-select-body {
   padding: 20px 10px;
}
.demo-chart-wrapper {
   .chart-selector {
      width: 320px;
   }
}
</style>
